import { EditEmployee } from './EditEmployee.main';

export { EditEmployee };
